import LocalEvaluateRequest from "../../../../mode/local/LocalEvaluateRequest"
import ExperimentEvaluateRequest from "../../ExperimentEvaluateRequest"
import { ExperimentConfig, HackleUser } from "../../../../../model/model"
import WorkspaceConfig from "../../../../../workspace/config/WorkspaceConfig"

export default class ExperimentLocalEvaluateRequest implements LocalEvaluateRequest, ExperimentEvaluateRequest {
  private constructor(
    readonly workspace: WorkspaceConfig,
    readonly entity: ExperimentConfig,
    readonly user: HackleUser,
    readonly record: boolean
  ) {}

  get experiment(): ExperimentConfig {
    return this.entity
  }

  toString(): string {
    return `ExperimentLocalEvaluateRequest(type=${this.entity.type}, key=${this.entity.key})`
  }

  static of(
    workspace: WorkspaceConfig,
    user: HackleUser,
    experiment: ExperimentConfig,
    record = true
  ): ExperimentLocalEvaluateRequest {
    return new ExperimentLocalEvaluateRequest(workspace, experiment, user, record)
  }
}
